import { Link } from '@tanstack/router'

import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import { numberWithCommas } from '../../utils/number'

interface PlatformProps {
  link?: string
  label: string
  note?: string
  onClick?: () => void
  active?: boolean
  icon: string
  amounts?: {
    minimum: number
    maximum: number
  }
  from?: 'withdraw' | 'deposit'
}

const Platform = ({
  link,
  active,
  onClick,
  icon,
  amounts,
  label,
  from = 'withdraw',
}: PlatformProps) => {
  const theme = useBoundStore(state => state.common.theme)

  const isDeposit = from === 'deposit'

  return (
    <Link params={{ id: link ?? '' }}>
      <div
        className={classNames(
          'w-[200px] h-[80px] rounded-[10px] lg:h-[90px] mb-3 pt-3 transition-all duration-200 ease-in-out',
          active
            ? 'deposit-payment-active dark:bg-primary border-[2px] border-highlight dark:!border-highlight-gold dark:text-[#f6e0a0]'
            : 'border-secondary-txt-20 border',
        )}
        style={
          active && theme === 'light'
            ? {
                background:
                  'linear-gradient(to bottom, color-mix(in srgb, var(--highlight) 20%, transparent), transparent)',
              }
            : undefined
        }
        onClick={onClick}>
        <img
          src={icon}
          alt="Alipay"
          className="w-[30px] object-contain lg:w-[45px] h-[30px] lg:h-[45px] mx-auto"
        />
        {isDeposit ? (
          <p className="text-sm text-center mt-2 text-secondary-txt font-Avenir-Medium">
            {amounts &&
              `${numberWithCommas(amounts.minimum)}-${numberWithCommas(amounts.maximum)}`}
          </p>
        ) : (
          <p className="text-sm text-center text-txt font-Avenir-Medium">
            {label}
          </p>
        )}
      </div>
    </Link>
  )
}

export default Platform
